"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circle = exports.arc99999 = exports.arc20 = exports.arc12 = exports.arc8 = exports.arc4 = void 0;
exports.arc4 = "4px";
exports.arc8 = "8px";
exports.arc12 = "12px";
exports.arc20 = "20px";
exports.arc99999 = "99999px";
exports.circle = "50%";